import React, { useState } from 'react';
import styles from './infoPayment.module.scss';
import { useSelector } from 'react-redux';
import { getTotal } from 'Containers/Payments/store/selectors';
import Modal from 'Containers/Common/Modal';
import { useTranslation } from 'react-i18next';
import clx from 'classnames';
import { ChevronRight, Wallet, X } from 'lucide-react';

const InfoPayment = ({ balance, isMobile }) => {
  const { t } = useTranslation();
  const { total: totalRows, saldo: totalEuro, balanceRows } = useSelector(getTotal());
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalProps, setModalProps] = useState({
    title: '',
    commissions: 0,
    balance: 0,
    nPay: 0,
    noFee: 0,
    info: '',
  });

  const totCommissions = balance * 0.029 + balanceRows * 0.15;
  const totEuroCommissions = totalEuro * 0.029 + totalRows * 0.15;

  const totPay = balance > 0 ? balance - totCommissions * 1.22 : 0;
  const totEuroPay = totalEuro > 0 ? totalEuro - totEuroCommissions * 1.22 : 0;

  const handleModal = (payload) => {
    setModalProps(payload);
    setIsOpenModal(true);
  };

  return (
    <div className={clx(styles.container, { [styles.container_mbl]: isMobile })}>
      <Modal
        isModalOpen={isOpenModal}
        setIsModalOpen={() => setIsOpenModal(false)}
        width={'fit-content'}
        height={'fit-content'}
        showCloseBtn={false}
      >
        <button
          type="button"
          className={styles.close}
          onClick={() => setIsOpenModal(false)}
          aria-label={t('common.actions.cancel')}
        >
          <X size={16} strokeWidth={2.2} />
        </button>
        <div className={clx(styles.modal, { [styles.modal_mbl]: isMobile })}>
          <div className={styles.head}>
            <span>{modalProps.title}</span>
            <h1>€ {modalProps.balance}</h1>
            <p className={styles.head_info}>{modalProps.info}</p>
          </div>
          <div className={styles.details}>
            <div className={styles.info}>
              <span>{t('payments.infoPayment.payments')}</span>
              <span>{modalProps.nPay}</span>
            </div>
            <div className={styles.info}>
              <span>{t('payments.infoPayment.grossAmount')}</span>
              <span>€ {modalProps.noFee}</span>
            </div>
            <div className={styles.info}>
              <span>
                {t('payments.infoPayment.commissions')}
                <sup>*</sup>
              </span>
              <span>€ {modalProps.commissions}</span>
            </div>
          </div>
          <div className={styles.footer}>
            <sup>*</sup>
            {t('payments.infoPayment.commissionsInfo')}
          </div>
        </div>
      </Modal>
      <div className={styles.title_row}>
        <span className={styles.title_icon} aria-hidden="true">
          <Wallet size={16} strokeWidth={2.2} />
        </span>
        <h2 className={styles.title}>{t('payments.infoPayment.generalPaymentsRecap')}</h2>
      </div>
      <button
        type="button"
        className={styles.item}
        onClick={() =>
          handleModal({
            title: t('payments.infoPayment.totalBalance'),
            balance: totEuroPay.toFixed(2),
            commissions: (totEuroCommissions * 1.22).toFixed(2),
            nPay: totalRows,
            noFee: totalEuro.toFixed(2),
            info: t('payments.infoPayment.totalPaymentsInfo'),
          })
        }
      >
        <span>{t('payments.infoPayment.totalBalance')}</span>
        <div className={styles.saldo}>
          <span>€ {totEuroPay.toFixed(2)}</span>
          <ChevronRight size={16} strokeWidth={2.2} />
        </div>
      </button>
      <button
        type="button"
        className={styles.item}
        onClick={() =>
          handleModal({
            title: t('payments.infoPayment.availableBalance'),
            balance: totPay.toFixed(2),
            commissions: (totCommissions * 1.22).toFixed(2),
            nPay: balanceRows,
            noFee: balance.toFixed(2),
            info: t('payments.infoPayment.availableBalanceInfo'),
          })
        }
      >
        <span>{t('payments.infoPayment.availableBalance')}</span>
        <div className={styles.saldo}>
          <span className={styles.highlight}>€ {totPay.toFixed(2)}</span>
          <ChevronRight size={16} strokeWidth={2.2} />
        </div>
      </button>
    </div>
  );
};

export default InfoPayment;
